import angular from 'angular'
import React from 'react'
import { reactular } from '@vendhq/reactular'
import { useT } from '@transifex/react'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'
import {
  QuickReceipt,
  QuickReceiptListItem,
  QuickReceiptDateItem,
  QuickReceiptRegisterItem,
} from '../quick-receipt/QuickReceipt'
import { useCashMovementsTypes } from '../../cash-management/utils/useCashMovementTypes'

interface CashMovementData {
  amount: string
  date: string
  note?: string
  type: string
  username: string
}

interface CashMovementReceiptProps {
  data: CashMovementData
}

export const CashMovementReceipt: React.FC<CashMovementReceiptProps> = ({
  data,
}) => {
  const vdCurrencyFilter = useVdCurrencyFilter()
  const t = useT()
  const cashMovementTypes = useCashMovementsTypes()

  return (
    <QuickReceipt
      title={cashMovementTypes(data.type)}
      subTitle={vdCurrencyFilter(data.amount)}
      items={
        <>
          <QuickReceiptDateItem value={data.date} />
          <QuickReceiptListItem label={t('User')} value={data.username} />
          <QuickReceiptRegisterItem />
          <QuickReceiptListItem label={t('Note')} value={data.note || '-'} />
        </>
      }
    />
  )
}

angular
  .module('webregister.components')
  .component(
    'wrPrintCashMovementReceipt',
    reactular(CashMovementReceipt, ['data'], 'reactWrapper')
  )
